import { useGetApiV1SerievideoVideoidLangsId } from '@/shared/api/generated';

/**
 * Hook para obter um Idioma do Vídeo por ID.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serievideo/{videoId}/langs/{id}`.
 * Desabilitado quando `langId` é `undefined` (tela de criação).
 *
 * @param videoId - ID do vídeo
 * @param langId - ID do idioma; omitir na criação
 *
 * @example
 * ```tsx
 * const { lang, isLoading } = useSerieVideoLang(videoId, langId);
 * ```
 */
export function useSerieVideoLang(videoId: number, langId: number | undefined) {
  const query = useGetApiV1SerievideoVideoidLangsId(videoId, langId as number, undefined, {
    query: { enabled: langId !== undefined },
  });

  return {
    lang: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
